import { apiGatewayClient } from './api'
import { isAuthenticated } from 'services/self'

export const submitFeedback = (message) => {
  return isAuthenticated() ? apiGatewayClient()
    .then(client => {
      return client.post('/feedback', {}, { message }, {})
    }) : false
}
